export default "__VITE_PUBLIC_ASSET__ef13114c__"